/* global process */
import React from 'react';
import { useSelector } from 'react-redux';

import Base from '../Base';
import NavLink from '../NavLink';

import { isSaltLiteMode } from 'store/mode';

const isDev = process.env.NODE_ENV === 'development';

const HeaderToolsetComponent = () => {
  const isSaltLite = useSelector(state => isSaltLiteMode(state));

  return (
    <Base>
      {
        !isSaltLite &&
        <ul className="header-nav__menu">
          <NavLink to="/toolset/dataset" title="View and manipulate your data set" >Dataset</NavLink>
          <NavLink to="/toolset/descriptive-statistics" title="View summary statistics includin mean, standard deviation, etc.">Descriptive Statistics</NavLink>
          <NavLink to="/toolset/charts-and-graphs" title="Create histograms, box, plot, bar charts, etc.">Charts And Graphs</NavLink>
          <NavLink to="/toolset/distributions" title="Calculate areas under normal, T, F and Chi-Square distribution curves">Distribution Calculators</NavLink>
          <NavLink to="/toolset/sampling-distributions" title="Generate random samples from your data">Sampling</NavLink>
          <NavLink to="/toolset/inferential-statistics" title="Use a random sample of data taken from a population to describe and make inferences about the population">Inferential Statistics</NavLink>
          {
            // Here we check environment to hide non-updated pages on production
            isDev &&
              <>
                <NavLink to="/toolset/bootstrap-confidence-intervals" title="Create bootstrap confidence intervals">Bootstrap Confidence Intervals</NavLink>
                <NavLink to="/toolset/randomization-hypothesis-testing" title="Conduct randomization tests">Randomization Hypothesis Testing</NavLink>
              </>
          }
          <NavLink to="/toolset/regression" title="Generate regression lines and make inferences">Regression</NavLink>
        </ul>
      }
    </Base>
  );
};

export default HeaderToolsetComponent;
